const state = {
  dashboardConfig: null,
  dashboardParams: [],
  category: null,
  quickSightDashboardConfig: null,
  isCountLoading: false,
  isTransporterLoading: false,
  isSlaLoading: false,
  isVehicleTypeLoading: false,
  isVehicleTypeUtiliLoading: false,
  count_data: null,
  transporter_data: null,
  sla_data: null,
  vehicletype_data: null,
  isVehicleTypeUtili_data: null,
  isKPILoading: false,
  kpi_data: null,
  isTransporterListLoading: false,
  transporterlist: null,
};

export default state;
